/*
 * File: StatusSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 14 Dec 2021 3:51:49 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Select, Space } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxState } from 'redux/rootReducer';
import { setFilterStatus } from 'redux/salesOrder/ordersSlice';
import { salesOrderApi } from 'redux/services/useMamaBearService';

const styles: InlineStylesModel = {
  titleColor: {
    // color: '#2F5596'
  },
  selectContainer: {
    minWidth: 150
  },
  labelUnfocused: {
    position: 'absolute',
    color: 'rgba(0,0,0,0.50)',
    pointerEvents: 'none',
    top: 5,
    left: 10,
    paddingLeft: 8,
    zIndex: 2,
    transition: 'all 0.3s ease'
  },
  labelFocused: {
    backgroundColor: 'white',
    // backgroundImage: 'linear-gradient(bottom white 50%, lightblue 50%)',
    position: 'absolute',
    paddingLeft: 5,
    marginLeft: 8,
    paddingRight: 5,
    zIndex: 2,
    top: -15,
    left: 8,
    transition: 'all 0.3s ease'
  }
};

export const StatusSearch = (): JSX.Element => {
  const { filterStatus } = useSelector((state: ReduxState) => state.salesOrders);

  const [inputValue, _setInputValue] = useState<string>(filterStatus || '');

  const [isLabelTop, _setIsLabelTop] = useState(inputValue !== '');

  const dispatch = useDispatch();

  const options = ['Draft', 'Posted', 'Both'];

  /* ****************** Functions ****************** */
  const handleStatusChange = (value: string): void => {
    _setInputValue(value);
    if (value !== 'Both' && value) {
      dispatch(setFilterStatus(value));
    }
    if (value === 'Both' || !value) {
      dispatch(setFilterStatus(undefined));
    }
    dispatch(salesOrderApi.util.invalidateTags(['SalesOrders']));
  };

  const handleBlur = (): void => {
    if (inputValue.length === 0) {
      _setIsLabelTop(false);
    }
  };

  useEffect(() => {
    if (inputValue.length === 0) {
      _setIsLabelTop(false);
    } else {
      _setIsLabelTop(true);
    }
    if (inputValue.length === 2 || inputValue.length === 0) dispatch(setFilterStatus(undefined));
  }, [inputValue, dispatch]);

  return (
    <Space direction="vertical" size="small">
      {/* <FancySelect onSelectChange={handleStatusChange} options={options} placeHolder="Status" defaultValue={options[0]} value={inputValue} width={150} /> */}
      <Space direction="vertical" size="small">
        {/* <Text>Status</Text> */}
        <Select
          mode="multiple"
          filterOption={(input, option): boolean => (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
          style={styles.selectContainer}
          onChange={handleStatusChange}
          onBlur={handleBlur}
          defaultValue={filterStatus}
          onFocus={(): void => _setIsLabelTop(true)}>
          <Select.Option key="Draft" value="Draft">
            Draft
          </Select.Option>
          <Select.Option key="Posted" value="Posted">
            Posted
          </Select.Option>
        </Select>
        <label style={isLabelTop ? styles.labelFocused : styles.labelUnfocused}>
          <span>Status</span>
        </label>
      </Space>
    </Space>
  );
};
